
import getConfigDetails from '../../services/config'
import CONSTANTS from '../constants'
import { getRequest } from '../../services'
import axios from 'axios'
import { APICONFIG } from '../apiConfig'

const token = localStorage.getItem('access_token')
const config = {
    headers: { 
        Authorization: `Bearer ${token}`,
        'X-ClientSecret':getConfigDetails?.CLIENT_SECRET
    }
}

export const getPartnerDetails = (requestData) => {
    return dispatch => {
        dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_REQUEST })
        let endpoint = `${APICONFIG.getPartnerDetailsReqUrl}/${requestData}`
        return axios.get(endpoint, config)
            .then(res => {
                return dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_REQUEST_SUCCESS, data: res.data.data, isFetching: false })
            })
            .catch(err => {
                return dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_REQUEST_FAIL, isFetching: false, errorMessage: err })
            })
    }
}





// GET PARTNER BY SLUG
export const getPartnerDetailsBySLug = (slug) => (dispatch) => {
    dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_REQUEST })
    return getRequest(`${APICONFIG.getPartnerBySlug}/${slug}`).then((res) => {
        dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_FAILURE, errorMessage: err })
        return err
    })
}